var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-thumbnails"},_vm._l((_vm.projects),function(project){return _c('ProjectThumbnail',{key:project.id,attrs:{"project":project,"invited":_vm.invited}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }